import {ensureHierarchy} from '#core/utils/config-utils.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';

import {ConnextraAnalyticsService} from './service.js';

import SCHEMA from './connextra.schema.yaml';

/**
 * Please note, conextra-frame.html is needed for this feature.
 * By default its copied from '#core/static.js' directory
 */
class ConnextraAnalyticsFeature extends AbstractFeature {
    get name() {
        return 'Connextra';
    }

    get configSchema() {
        return SCHEMA;
    }

    get isThirdParty() {
        return true;
    }

    get isTracker() {
        return true;
    }

    afterMojitoConfigBuild(mojitoConfig) {
        this.service = new ConnextraAnalyticsService(this.config);

        const services = ensureHierarchy(mojitoConfig, 'services.analytics.services');
        services.default = services.default || [];
        services.native = services.native || [];
        services.default.push(this.service);
        services.native.push(this.service);

        return super.afterMojitoConfigBuild();
    }
}

new ConnextraAnalyticsFeature(allFeatures);
